export type ObjectMap<T> = { [key: string]: T };

export type Metric =
  | 'decrement'
  | 'event'
  | 'gauge'
  | 'histogram'
  | 'increment'
  | 'set';

export type StatsdCounterData = ObjectMap<number> | Array<string> | string;
export type StatsdData = ObjectMap<number> | ObjectMap<number | string>;

export type StatsdApiClientOptions = {
  onError?: (e: Error) => void;
};
export type StatsdOptions = {
  // immediately send the event to the server (vs. batching and waiting)
  eager?: boolean;
  sampleRate?: number;
  tags?: Array<string>;
};

export type StatsdPayload = {
  data: StatsdData;
  metric: Metric;
  tags: Array<string>;
};
